import React from 'react';
import Head from 'next/head';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import { formatEventDate } from '@utils/dates';
import { useRollbarContext } from '@services/rollbar';
import ssrProvider from '@services/ssrProvider';
import { GET_DATA_FOR, getServerSideData } from '@services/dataHandler/getPageData';
import ReduxWrapper from '@services/store';
import EventDescriptionTemplate from '@features/eventDetail/templates/EventDescriptionTemplate';
import { selectEventDetail } from '@features/eventDetail/slices/eventDetailServerSlice';
import { getQueryEventId } from '@features/eventDetail/utils';

const DescriptionPage = () => {
  useRollbarContext('Event : DescriptionPage');
  const { t } = useTranslation();
  const router = useRouter();
  const event = useSelector(selectEventDetail(getQueryEventId(router.query)));
  return (
    <>
      <Head>
        <title>
          {`${t('head_EventTitle.message', { event: event.name })} ${t('head_siteTitle.message')}`}
        </title>
        <meta
          name="description"
          content={
            t('head_EventDescription.message',
              {
                eventName: event.name,
                eventDate: formatEventDate(event.date, event.dateFrom, event.dateTo),
                eventLocation: event.location,
                eventSport: event.eventType,
              })
          }
        />
      </Head>
      <EventDescriptionTemplate />
    </>
  );
};

export default DescriptionPage;

export const getServerSideProps = ReduxWrapper.getServerSideProps(
  (store) => async (serverSideContext) => ssrProvider({
    store,
    serverSideContext,
    process: async ({ store }) => {
      await getServerSideData(
        store,
        serverSideContext,
        GET_DATA_FOR.EVENT_DESCRIPTION
      );
    },
  })
);
